import cameraLoaderGif from "@assessment/assets/images/camera-loader.gif";
import { cn } from "@assessment/utils/cn";
import { useTranslation } from "react-i18next";

interface CameraPreviewLoaderProps {
  className?: string;
  showDelayedMessage?: boolean;
}

const CameraPreviewLoader = ({
  className,
  showDelayedMessage = false
}: CameraPreviewLoaderProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        "relative w-full h-full flex items-center justify-center bg-[#efefef] overflow-hidden",
        className
      )}
    >
      <div className="absolute inset-0 z-0 bg-[#efefef] animate-pulse" />
      <img
        src={cameraLoaderGif}
        alt={t("assessment.cameraPreview.loadingAlt")}
        className="absolute z-10 inset-0 m-auto w-16 h-16 md:w-20 md:h-20 object-contain pointer-events-none select-none"
      />
      {showDelayedMessage && (
        <div className="absolute top-6 left-0 z-20 w-full px-6">
          <p className="text-sm italic font-semibold text-gray-500">
            {t("assessment.cameraPreview.delayedMessage")}
          </p>
        </div>
      )}
    </div>
  );
};

export default CameraPreviewLoader;
